import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=0a0aba2b"
import script from "./app-main.vue?vue&type=script&lang=js"
export * from "./app-main.vue?vue&type=script&lang=js"
import style0 from "./app-main.vue?vue&type=style&index=0&id=0a0aba2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports